import {Resolvers} from "@apollo/client";

export const resolvers: Resolvers | Resolvers[] = {};
